export const CUSTOMER_URL = '/customer';
export const CUSTOMERS_URL = '/customers';
